
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { FileInfo } from '@/types/uploadFile'
@Component({
  name: 'WorkerDetails',
  filters: {
    imgListFormat (list: FileInfo[]) {
      const imgList = list.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }
  }
})
export default class extends Vue {
  @Prop() readonly id!: string
  @Prop() readonly detailsShow!: boolean

  private loading = false
  private dialogWidth = ''

  private info = {
    // 基础信息
    workerName: '',
    signProjectName: '',
    onSignRecord: {},
    offSignRecord: {},
    overtimeRecords: []
  }

  @Watch('detailsShow')
  isDetail (val: string) {
    val && this.getDetail()
  }

  getDetail () {
    // this.loading = true
    this.$axios.get(this.$apis.laborManage.selectYhSingleAttendanceDetail, { attendanceId: this.id }).then(res => {
      if (res) {
        this.info = res
      }
    }).finally(() => {
      // this.loading = false
      if (this.info.overtimeRecords.length) {
        this.dialogWidth = '761px'
      } else {
        this.dialogWidth = '517px'
      }
    })
  }

  handleClose () {
    // console.log('关闭弹窗')
    this.$emit('update:detailsShow', false)
    this.info = {
      workerName: '',
      signProjectName: '',
      onSignRecord: {},
      offSignRecord: {},
      overtimeRecords: []
    }
  }

  imgSrc (val: any) {
    // console.log('图片处理', val)
    if (val) {
      if (val === 'Y') {
        return require('../../../assets/img/attendance/card_replacement.svg')
      } else {
        return require('../../../assets/img/attendance/sign.svg')
      }
    }
  }
}
